<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn color="info" dark v-on="on" class="mb-2">
                Edit
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="text-h5">Edit Level Reward Set</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form v-model="isFormValid" ref="form">
                      <v-row>
                          <v-col cols="12">
                            <v-radio-group label="Qualification Logic" v-model="workingLogic" :disabled="!isEditable">
                              <v-radio label="All: must meet all qualifiers (AND)" value="AND"/>
                              <v-radio label="Any: must meet at least one qualifier (OR)" value="OR"/>
                            </v-radio-group>
                          </v-col>
                      </v-row>
                      <v-row class="mt-6">
                          <v-col cols="12">
                            <v-text-field
                              label="# Cycles Autoqualify"
                              v-model="workingAutoQualifyCycles"
                              type="number"
                              hide-spin-buttons
                              dense
                              :rules="requiredAndPositiveRule"
                              :disabled="!isEditable"
                            />
                          </v-col>
                      </v-row>
                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large @click="cancel">Cancel</v-btn>
                <v-btn id="saveButton" large class="blue white--text" @click="save" :disabled="!isFormValid || !isEditable">
                        Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { ValidationTool } from '@/util';
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class EditLogicDialog extends Vue {
  @Prop()
  logic!:string;

  @Prop()
  autoQualifyCycles!:number;

  @Prop({ default: false })
  isEditable!: boolean;

  workingLogic:string = '';

  workingAutoQualifyCycles:number = 0;

  dialog:boolean = false;

  isFormValid:boolean = true;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  @Watch('dialog')
  initialize() {
    if (this.dialog) {
      this.workingLogic = this.logic;
      this.workingAutoQualifyCycles = this.autoQualifyCycles;
    }
  }

  cancel() {
    const form: any = this.$refs.form;
    form.reset();
    this.dialog = false;
  }

  save() {
    this.$emit('save', this.workingLogic, this.workingAutoQualifyCycles);
    this.dialog = false;
  }
}
</script>

<style lang="scss" scoped>
</style>
